// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file entities/app/my_account/work_function_data.proto (package protos.entities.app.my_account, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { WorkFunction } from "../../../general/work_function_pb";
import { file_general_work_function } from "../../../general/work_function_pb";
import type { WorkDepartment } from "../../../general/work_department_pb";
import { file_general_work_department } from "../../../general/work_department_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file entities/app/my_account/work_function_data.proto.
 */
export const file_entities_app_my_account_work_function_data: GenFile = /*@__PURE__*/
  fileDesc("CjBlbnRpdGllcy9hcHAvbXlfYWNjb3VudC93b3JrX2Z1bmN0aW9uX2RhdGEucHJvdG8SHnByb3Rvcy5lbnRpdGllcy5hcHAubXlfYWNjb3VudCJ2ChBXb3JrRnVuY3Rpb25EYXRhEi4KCGZ1bmN0aW9uGAEgASgOMhwucHJvdG9zLmdlbmVyYWwuV29ya0Z1bmN0aW9uEjIKCmRlcGFydG1lbnQYAiABKA4yHi5wcm90b3MuZ2VuZXJhbC5Xb3JrRGVwYXJ0bWVudGIGcHJvdG8z", [file_general_work_function, file_general_work_department]);

/**
 * @generated from message protos.entities.app.my_account.WorkFunctionData
 */
export type WorkFunctionData = Message<"protos.entities.app.my_account.WorkFunctionData"> & {
  /**
   * @generated from field: protos.general.WorkFunction function = 1;
   */
  function: WorkFunction;

  /**
   * @generated from field: protos.general.WorkDepartment department = 2;
   */
  department: WorkDepartment;
};

/**
 * Describes the message protos.entities.app.my_account.WorkFunctionData.
 * Use `create(WorkFunctionDataSchema)` to create a new message.
 */
export const WorkFunctionDataSchema: GenMessage<WorkFunctionData> = /*@__PURE__*/
  messageDesc(file_entities_app_my_account_work_function_data, 0);

